import { store } from '../../configureStore';
import { getFullAddress, getShippingAddress } from './ContactInfoUtils';
import { getSession, isVfNYEnable } from './Helpers';

export const getAddressInfo = (billingAddress, shippingAddress, serviceAddress, isIspu = false) => {
  // Billing, Shipping and Service addresses
  const addressInfo = {
    isSameAddress: false,
    isSameBillingShipping: false,
    isSameBillingService: false,
    isSameShippingService: false,
    isDifferentAddress: true,
    shippingFullAddress: '',
    billingFullAddress: '',
    serviceFullAddress: '',
    sameAddressTitle: '',
    shippingAddressTitle: 'Shipping address',
    billingAddressTitle: 'Billing address',
    serviceAddressTitle: 'Service address',
    showBillingAddress: false,
    showServiceAddress: false,
  };

  if (!billingAddress || !shippingAddress || !serviceAddress) {
    return addressInfo;
  }

  addressInfo.shippingFullAddress = isIspu ? getFullStoreAddress(shippingAddress) : getFullAddress(shippingAddress);
  addressInfo.billingFullAddress = getFullAddress(billingAddress);
  addressInfo.serviceFullAddress = getFullAddress(serviceAddress);

  if (!isIspu) {
    if (
      billingAddress.zipCode &&
      serviceAddress.zipCode &&
      shippingAddress.zipCode &&
      billingAddress.zipCode === serviceAddress.zipCode &&
      billingAddress.zipCode === shippingAddress.zipCode
    ) {
      if (compareAddressLines(billingAddress, serviceAddress) && compareAddressLines(billingAddress, shippingAddress)) {
        addressInfo.isSameAddress = true;
        addressInfo.sameAddressTitle = 'Shipping, Service & Billing address';
        addressInfo.isDifferentAddress = false;
        return addressInfo;
      }
    }

    if (
      billingAddress.zipCode &&
      shippingAddress.zipCode &&
      billingAddress.zipCode === shippingAddress.zipCode &&
      compareAddressInfo(billingAddress, shippingAddress)
    ) {
      addressInfo.isSameBillingShipping = true;
      addressInfo.sameAddressTitle = 'Shipping & Billing address';
      addressInfo.isDifferentAddress = false;
      addressInfo.showServiceAddress = true;
      return addressInfo;
    }

    if (
      serviceAddress.zipCode &&
      shippingAddress.zipCode &&
      shippingAddress.zipCode === serviceAddress.zipCode &&
      compareAddressLines(shippingAddress, serviceAddress)
    ) {
      addressInfo.isSameShippingService = true;
      addressInfo.sameAddressTitle = 'Shipping & Service address';
      addressInfo.isDifferentAddress = false;
      return addressInfo;
    }
  }

  if (
    billingAddress.zipCode &&
    serviceAddress.zipCode &&
    billingAddress.zipCode === serviceAddress.zipCode &&
    compareAddressLines(billingAddress, serviceAddress)
  ) {
    addressInfo.isSameBillingService = true;
    addressInfo.sameAddressTitle = 'Service & Billing address';
    addressInfo.isDifferentAddress = false;
    return addressInfo;
  }

  return addressInfo;
};

export const compareAddressLines = (address1, address2) => {
  if (!address1 || !address2 || !address1.addressLine1) {
    return false;
  }
  const { addressLine1, addressLine2 = '' } = address1;
  const { addressLine1: streetLine1 = '', addressLine2: streetLine2 = '' } = address2;
  return !!(addressLine1 === streetLine1 && addressLine2 === streetLine2);
};

export const compareAddressInfo = (address1, address2) => {
  if (!address1 || !address2 || !address1.zipCode) {
    return false;
  }

  const { addressLine1 = '', addressLine2 = '', zipCode } = address1;
  const { addressLine1: streetLine1 = '', addressLine2: streetLine2 = '', zipCode: zipCode2 = '' } = address2;
  return !!(zipCode === zipCode2 && addressLine1 === streetLine1 && addressLine2 === streetLine2);
};

export const getFullStoreAddress = (storeInfo) => {
  if (!storeInfo) return '';
  const { address1, address2, city, state, zipCode } = storeInfo;
  const address = [];
  if (address1) address.push(address1);
  if (address2) address.push(address2);
  if (city) address.push(city);
  if (state) address.push(state);
  if (zipCode) address.push(zipCode);
  return address.length ? address.join(', ') : '';
};

export const AddressZipCodeValidation = (shippingData) => {
  const { storeAddress = '', zipcode = '' } = shippingData || {};
  if (storeAddress) {
    return storeAddress.includes(zipcode) ? storeAddress : `${storeAddress}, ${zipcode}`;
  }
  return getFullStoreAddress(shippingData);
};

export const getStoreAddress = (storeInfo) => {
  if (!storeInfo) return storeInfo;

  const { address1 = '', address2 = '', city = '', state = '', zipCode = '' } = storeInfo;
  const address = {
    addressLine1: address1,
    addressLine2: address2,
    city,
    state,
    zipCode,
  };

  return address;
};

export const getLqAddress = () => {
  const lqResponse = getSession('LQResponse') ? JSON.parse(getSession('LQResponse')) : '';
  if (lqResponse && lqResponse !== undefined && lqResponse.output) {
    const lqAddress = getShippingAddress(lqResponse.output);
    return lqAddress;
  }

  const lqBulkResponse = getSession('LQBulkResponse') ? JSON.parse(getSession('LQBulkResponse')) : '';
  if (lqBulkResponse && lqBulkResponse.data?.output) {
    const lqBulkAddress = getShippingAddress(lqBulkResponse.data.output.billingAddress);
    return lqBulkAddress;
  }

  const state = store.getState();
  const address = state.cartDetails?.cartDetailsJson?.shippingDetails?.[0]?.address ?? null;
  if (address) {
    const shippingAddress = getShippingAddress(address);
    return shippingAddress;
  }

  return null;
};

export const getIsVfny = () => {
  const lqAddress = getLqAddress();
  const { state = '' } = lqAddress || '';
  const isVfny = state === 'NY' && isVfNYEnable();
  return isVfny;
};

export const getNetworkBandwidthType = () => {
  let LQResponseData = getSession('LQResponse');
  if (LQResponseData) {
    LQResponseData = JSON.parse(LQResponseData);
  }
  return LQResponseData?.output?.networkBandwidthType || '';
};

export const getSpoid = () => {
  const networkBandwidthType = getNetworkBandwidthType();
  if (networkBandwidthType === 'mmw' || networkBandwidthType === 'mmwave') {
    return '3325';
  }
  if (networkBandwidthType === 'cbd' || networkBandwidthType === 'lte') {
    return '3327';
  }
  return 'no orderid';
};
